import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRow,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
  useIonViewWillLeave,
} from "@ionic/react";
import Lightning from "assets/icons/Lightning";
import { informationCircleOutline } from "ionicons/icons";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { validateEmail } from "utils/Utils.js";
import { AuthContext } from "../../contexts/AuthContext";

const ForgotPassword = () => {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [disabled, setDisabled] = useState(true);

  const {
    forgotPassword,
    errorMessage,
    setErrorMessage,
    successMessage,
    setSuccessMessage,
    userEmail,
    handleUserEmail,
    loading,
  } = authContext;

  useEffect(() => {
    setDisabled(!userEmail);
  }, [userEmail]);

  const requestCode = async () => {
    if (!validateEmail(userEmail)) return setErrorMessage("Invalid email.");
    await forgotPassword();
    handleUserEmail("");
  };

  useIonViewWillLeave(() => {
    setSuccessMessage("");
    setErrorMessage("");
  });

  return (
    <IonPage className={"login-page-root"}>
      <IonContent fullscreen>
        <div className={"parent-container"}>
          <div className={"inner-container"}>
            <IonHeader className={"fixed-header ion-hide-md-up"}>
              <IonToolbar>
                <IonButtons slot="start">
                  <IonButton onClick={() => history.goBack()} color="dark">
                    <Lightning height={32} />
                  </IonButton>
                </IonButtons>
                <IonTitle>Reset your password</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonHeader collapse="condense" className={"dynamic-header"}>
              <div className={"logo-container ion-hide-md-down"}>
                <Lightning height={32} />
              </div>
              <IonToolbar>
                <IonTitle size="large">Reset your password</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonGrid>
              <IonRow>
                <IonCol>
                  <IonText>
                    Enter the email address you used to register with Oshi and
                    we'll send you instructions to reset your password.
                  </IonText>
                </IonCol>
              </IonRow>
            </IonGrid>
            <IonList lines="none">
              <IonItem className={"bordered"}>
                <IonLabel position="floating">Email address</IonLabel>
                <IonInput
                  required
                  type="email"
                  inputmode="email"
                  name="email"
                  onIonChange={(e) => handleUserEmail(e)}
                  value={userEmail}
                />
              </IonItem>
              {errorMessage ||
                (successMessage && (
                  <IonItem className={"error-message"}>
                    <IonIcon
                      slot="start"
                      icon={informationCircleOutline}
                      size="small"
                      color={errorMessage ? "danger" : "success"}
                    />
                    <IonLabel color={errorMessage ? "danger" : "success"}>
                      {errorMessage || successMessage}
                    </IonLabel>
                  </IonItem>
                ))}
              <IonButton
                disabled={disabled || loading}
                expand="block"
                onClick={() => requestCode()}
              >
                {loading ? <IonSpinner name="crescent" /> : "Send instructions"}
              </IonButton>
            </IonList>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ForgotPassword;
